module.exports = __webpack_public_path__ + "static/media/m2.cfa507a4.jpg";